import Tasks from "../components/Tasks";

export default function TasksPage() {
  return <Tasks />;
}
